import { call, put, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../utilz';
import {
  getPurchaseOrderInfoInError,
  getPurchaseOrderInfoInSuccess,
  getPurchaseOrderListInError,
  getPurchaseOrderListInSuccess,
} from './PurchaseOrderActions';
import { getPurchaseOrderInfoEffect, getPurchaseOrderListEffect } from './PurchaseOrderEffects';
import PurchaseOrderTypes from './PurchaseOrderTypes';

function* getPurchaseOrderList({ payload }) {
  try {
    const { data } = yield call(getPurchaseOrderListEffect, payload);
    yield put(getPurchaseOrderListInSuccess({ data: data.totalData }));
  } catch (e) {
    yield put(getPurchaseOrderListInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getPurchaseOrderInfo({ payload }) {
  try {
    const { data } = yield call(getPurchaseOrderInfoEffect, payload);
    yield put(
      getPurchaseOrderInfoInSuccess({
        data: data,
      }),
    );
  } catch (e) {
    yield put(getPurchaseOrderInfoInError({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* PurchaseOrderSagas() {
  yield takeLatest(PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_PROGRESS, getPurchaseOrderList);
  yield takeLatest(PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_PROGRESS, getPurchaseOrderInfo);
}
